import React, { useEffect, useState } from "react";
import { useGetOrganizationDocuments } from "../api/organization";
import { Image, Skeleton } from "antd";
import WithAuth from "../hoc/WithAuth";
import { CloudUploadOutlined } from "@ant-design/icons";
import UploadDocumentModal from "./UploadDocuments";
import { useParams } from "react-router-dom";
import { AuthContextValue, useAuth } from "../providers/AuthProvider";

function DocumentsPage() {
  const { id } = useParams();
  const { user } = useAuth() as AuthContextValue;
  const {
    data: documents,
    isLoading,
    refetch,
  } = useGetOrganizationDocuments(user?.mfiId);
  const [open, setOpen] = useState(false);

  const hideModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (user) {
      refetch();
    }
  }, [user, open]);
  return (
    <div className="p-6 max-w-7xl mx-auto">
      <UploadDocumentModal open={open} hideModal={hideModal} />
      
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl font-bold text-gray-800">Documents</h1>
        <button
          onClick={() => setOpen(true)}
          className="bg-blue-600 hover:bg-green-500 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
        >
          <CloudUploadOutlined style={{ fontSize: 50 }} />
          Upload Document
        </button>
      </div>

      {isLoading && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <Skeleton.Input
              key={i}
              active
              className="w-full h-64 rounded-lg"
            />
          ))}
        </div>
      )}

      {documents && documents.data && documents.data.data && documents.data.data.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {documents.data.data.map((doc: any) => (
            <div
              key={doc.id}
              className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow border border-gray-100 overflow-hidden"
            >
              <div className="aspect-video bg-gray-50 relative">
                <Image
                  preview
                  src={`data:image/*;base64,${doc.file}`}
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="p-4">
                <h3 className="font-medium text-gray-800 truncate">
                  {doc.name}
                </h3>
                {doc.isBack && (
                  <span className="text-sm text-gray-500">(Back side)</span>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex justify-center mt-20 ">
          <div className="text-center max-w-md">
            <div className="mx-auto bg-gray-100 p-4 rounded-full w-max mb-4">
              <CloudUploadOutlined className="text-4xl text-gray-400" />
            </div>
            <h2 className="text-xl font-semibold text-white mb-2">
              No Documents Found
            </h2>
            <p className="text-white mb-6">
              Upload your legal documents to complete your subscription
              approval process.
            </p>
            <button
              onClick={() => setOpen(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors"
            >
              Upload First Document
            </button>
          </div>
        </div>
      )}
    </div>
  );
}


export default WithAuth(DocumentsPage);
